import { PassedInitialConfig } from "angular-auth-oidc-client";

export const authConfig: PassedInitialConfig = {
  config: {
    authority:
      "https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_95Ck0cJfx",
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: "78n5c5t6bntm2jdkkoao3rhian",
    scope: "phone openid email", // 'openid profile offline_access ' + your scopes
    responseType: "code",
    // silentRenew: true,
    // useRefreshToken: true,
    // renewTimeBeforeTokenExpiresInSeconds: 30,
  },
};
